export const ActivityBasedSchedulingRoutes = [
    {
        "url": "/forecasts-projections/:start_date",
        "name": "appLayout.schedule.forecasts-projects",
        "route_dependencies": [
            {
                type: 'chunk',
                loader: () => {
                    return import("@ngmodules/activity-based-scheduling/activity-based-scheduling.downgrade.module");
                }
            },
            { path: "d3", type: "library", "name": "d3" },
            { path: "c3", type: "library", "name": "c3" }
        ]
    },
    {
        "url": "/demand-forecasting?date&step&openAdjustment",
        "name": "appLayout.schedule.demand-forecasting",
        "route_dependencies": [
            {
                type: 'chunk',
                loader: () => {
                    return import("@ngmodules/activity-based-scheduling/activity-based-scheduling.downgrade.module");
                }
            },
            { path: "d3", type: "library", "name": "d3" },
            { path: "c3", type: "library", "name": "c3" }
        ]
    },
];
//# sourceMappingURL=activity-based-scheduling.routes.js.map